module.exports = __webpack_public_path__ + "img/vehicle-options-white-mitsu.bb4b6f0b.png";